import { render, staticRenderFns } from "./StatsPhoenixGeo.vue?vue&type=template&id=c93f35ec&"
import script from "./StatsPhoenixGeo.vue?vue&type=script&lang=js&"
export * from "./StatsPhoenixGeo.vue?vue&type=script&lang=js&"
import style0 from "./StatsPhoenixGeo.vue?vue&type=style&index=0&id=c93f35ec&prod&lang=scss&"
import style1 from "./StatsPhoenixGeo.vue?vue&type=style&index=1&id=c93f35ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports